import React from 'react';

const ApplicationContext = React.createContext(undefined);

export { ApplicationContext };
